export const error = {};
error.authority = {
  code: 400,
  message: '입력 정보가 부족합니다.',
};
